import api from "@/services/api";
import { Promise } from "core-js";
import route from "@/router/index";

const BASE_URL = "/sale/down-payments";

//#region state
const state = {
  saleDownPayments: [],
  lastFormNumber: null,
  saleDownPayment: {},
  totalPercentageDownPayment: [],
};
//#endregion

//#region getters
const getters = {};
//#region

//#region actions
const actions = {
  async create(context, body) {
    try {
      const response = await api.post(BASE_URL, body);
      if (response.status === 200) {
        context.dispatch(
          "toast",
          { type: "success", message: "Success Saved Data" },
          { root: true }
        );
        route.push({ name: "Detail Sale Down Payment", params: { id: response.data } });
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getLastFormNumber(context) {
    try {
      const response = await api.get(`${BASE_URL}/form-number`);
      if (response.status === 200) {
        let num = null;
        let date = new Date();
        if (response.data === "New") {
          num = `SDP.${date.getFullYear()}.${date.getMonth() + 1}.00001`;
        } else {
          const lastNumber = response.data ? response.data.split(".")[3] : "";
          const ctx = "" + (parseInt(lastNumber) + 1);
          const end = lastNumber.substr(0, lastNumber.length - ctx.length) + ctx;
          num = `SDP.${date.getFullYear()}.${date.getMonth() + 1}.${end}`;
        }
        context.commit("SET_LAST_FORM_NUMBER", num);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getAll(context) {
    try {
      const response = await api.get(`${BASE_URL}`);
      if (response.status === 200) {
        context.commit("SET_SALE_DOWN_PAYMENTS", response.data);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getJournal(context, id) {
    try {
      const response = await api.get(`${BASE_URL}/journal/${id}`);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async linkDo(context, params) {
    try {
      const response = await api.post(`${BASE_URL}/link-do/${params.id}`, params.body);
      if (response.status === 200) {
        window.location.reload();
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async linkDoV2(context, params) {
    try {
      const response = await api.post(`${BASE_URL}/link-do/v2/${params.id}`, params.body);
      if (response.status === 200) {
        window.location.reload();
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async updateRemark(context, body) {
    try {
      const response = await api.post(`${BASE_URL}/update/remark`, body);
      if (response.status === 200) {
        window.location.reload();
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getHistoryRemark(context, id) {
    try {
      const response = await api.get(`${BASE_URL}/history/remark/${id}`);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getById(context, saleDownPaymentId) {
    try {
      const response = await api.get(`${BASE_URL}/${saleDownPaymentId}`);
      // if (response.status === 200) {
      //   context.commit("SET_SALE_DOWN_PAYMENT", response.data);
      // }
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async totalDownPayment(context, id) {
    try {
      const response = await api.get(`${BASE_URL}/total-percentage/${id}`);
      if (response.status === 200) {
        context.commit("SET_TOTAL_PERCENTAGE_DOWN_PAYMENT", response.data);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async update(context, body) {
    try {
      const response = await api.put(`${BASE_URL}/${body.id}`, body);
      if (response.status === 200) {
        window.location.reload();
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async cancelInvoice(context, params) {
    try {
      const response = await api.get(`${BASE_URL}/cancel`, params);
      if (response.status === 200) {
        route.push({ name: "Sale Down Payment" });
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async cancelInvoiceV2(context, body) {
    try {
      const response = await api.post(`${BASE_URL}/v2/cancel`, body.form, {
        params: { cancel: body.cancel },
      });
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getListConvert(context, params) {
    try {
      const response = await api.get(`${BASE_URL}/converts`, params);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async convertDP(context, body) {
    try {
      const response = await api.post(`${BASE_URL}/converts`, body);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async saveTaxSale(context, body) {
    try {
      const response = await api.post(`${BASE_URL}/tax-serial-number`, body);
      if (response.status === 200) {
        context.dispatch(
          "toast",
          { type: "success", message: "Success Saved Data" },
          { root: true }
        );
        return Promise.resolve(response);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async validateBomlist(context, body) {
    try {
      const response = await api.post(`${BASE_URL}/validate-bom-list`, body);
      if (response.status === 200) {
        return Promise.resolve(response);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
};
//#endregion

//#region mutations
const mutations = {
  SET_LAST_FORM_NUMBER(state, payload) {
    state.lastFormNumber = payload;
  },
  SET_SALE_DOWN_PAYMENT(state, payload) {
    state.saleDownPayment = payload;
  },
  SET_SALE_DOWN_PAYMENTS(state, payload) {
    state.saleDownPayments = payload;
  },
  SET_TOTAL_PERCENTAGE_DOWN_PAYMENT(state, payload) {
    state.totalPercentageDownPayment = payload;
  },
};
//#endregion

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
